<template lang="pug">
.coaching-chat-wrapper(
  ref="scrollWrapper"
  :class="{ 'expanded-view' : isExpandedView }")
  .chat-history(v-if="!coachingMessagesLoaded")
    .loading-dots
      .dot1
      .dot2
      .dot3
  .chat-history(v-if="coachingMessagesLoaded")
    transition-group(name="chat-mode-change" mode="out-in")
      div.chat-canned-responses(v-if="cannedResponsePickerShown" key="canned-response")
        canned-response-picker(
          :canned-responses-shown="cannedResponsePickerShown"
          :close-picker-function="closeCannedResponsePicker"
          @populate-coach-message="populateCoachMessage")
      div.coaching-chat(v-else key="chat")
        .header-row
          .item.chat-heading
            h3.heading Coaching Chat History
              br
              span.coaching-status {{ coachingMessages.status }}
          .item.chat-actions
            button.btn.muted.btn-show-canned-responses(
              v-if="isUsersCoach"
              @click.prevent="showCannedResponsePicker"
              value="Show canned responses"
              title="Show canned responses")
              svg.svgicon(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 512 512')
                path(d='M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM336 105.4c-12.5-12.5-32.8-12.5-45.2 0l-126.1 126c-2 2-3.4 4.5-4.2 7.3l-16 61.2c-1.4 5.5.1 11.3 4.2 15.4 3 3 7.1 4.7 11.3 4.7 1.3 0 2.7-.2 4-.5l61.2-16c2.8-.7 5.3-2.2 7.3-4.2l126.1-126.1c12.5-12.5 12.5-32.8 0-45.2L336 105.4zM213 273.6l-30.6 8 8-30.6 75-75 22.6 22.6-75 75zm97.6-97.6L288 153.4l25.4-25.4 22.6 22.6-25.4 25.4z')
            button.btn.muted.btn-show-expanded-chat(
              v-if="!isExpandedView"
              @click.prevent="showExpandedCoachChat"
              value="Show expanded chat"
              title="Show expanded chat")
              svg.svgicon(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 24 24')
                path(d="M24 23.36a.65.65 0 0 1-.64.64h-7.29a.65.65 0 0 1-.64-.64v-1.5a.65.65 0 0 1 .64-.65l3.32.11.06-.05L12 13.82l-7.45 7.45.06.05 3.32-.11a.65.65 0 0 1 .64.65v1.5a.65.65 0 0 1-.64.64H.64a.58.58 0 0 1-.45-.19.58.58 0 0 1-.19-.45v-7.29a.58.58 0 0 1 .19-.45.58.58 0 0 1 .45-.19h1.5a.65.65 0 0 1 .65.64l-.11 3.32v.06l7.5-7.45-7.45-7.45v.06l.11 3.32a.65.65 0 0 1-.65.64H.64a.58.58 0 0 1-.45-.19.58.58 0 0 1-.19-.45V.64A.58.58 0 0 1 .19.19.58.58 0 0 1 .64 0h7.29a.58.58 0 0 1 .45.19.58.58 0 0 1 .19.45v1.5a.65.65 0 0 1-.64.65l-3.32-.11h-.06l7.45 7.5 7.45-7.45h-.06l-3.32.11a.65.65 0 0 1-.64-.65V.64a.58.58 0 0 1 .19-.45.58.58 0 0 1 .45-.19h7.29a.58.58 0 0 1 .45.19.58.58 0 0 1 .19.45v7.29a.65.65 0 0 1-.64.64h-1.5a.65.65 0 0 1-.65-.64l.11-3.32-.05-.06L13.82 12l7.45 7.45.05-.06-.11-3.32a.65.65 0 0 1 .65-.64h1.5a.65.65 0 0 1 .64.64z")
            button.btn.muted.btn-hide-expanded-chat(
              v-if="isExpandedView"
              @click.prevent="hideExpandedCoachChat"
              value="Hide expanded chat"
              title="Hide expanded chat")
              svg.svgicon(xmlns='http://www.w3.org/2000/svg', viewBox="0 0 320 512")
                path(d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z")

        .compose-message(
          v-if="isUsersCoach && userNotDisabled")
          textarea(
            v-model="messageText"
            ref="messageInput")

          template(v-if="messageAttachments.length < 5")
            attachment-input(@add-attachment="addAttachment")
          template(v-else)
            .compose-message-validation.info
              div.svg-icon
                svg(viewBox="0 0 512 512" class="svgicon" aria-hidden="true" focusable="false")
                  path(d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z")
              span.validation-msg You've reached the maximum of 5 attachments per message

          attachment-list(
            :attachments="messageAttachments"
            @update-attachments="setAttachments")

          .compose-message-validation(v-if="messageTextValidationMessage.length > 0")
            div.svg-icon
              svg(viewBox="0 0 32 32" class="svgicon" aria-hidden="true" focusable="false")
                path(d="M9.79 1.27a15.87 15.87 0 0 1 12.42 0 15.75 15.75 0 0 1 8.52 8.52 15.87 15.87 0 0 1 0 12.42 15.75 15.75 0 0 1-8.52 8.52 15.87 15.87 0 0 1-12.42 0 15.75 15.75 0 0 1-8.52-8.52 15.87 15.87 0 0 1 0-12.42 15.75 15.75 0 0 1 8.52-8.52zM16 30a13.69 13.69 0 0 0 5.44-1.11 14.13 14.13 0 0 0 4.47-3 14 14 0 0 0 3-4.46 13.92 13.92 0 0 0 0-10.89 13.76 13.76 0 0 0-7.45-7.45 13.92 13.92 0 0 0-10.89 0 14 14 0 0 0-4.46 3 14.13 14.13 0 0 0-3 4.47 13.92 13.92 0 0 0 0 10.89 13.7 13.7 0 0 0 7.44 7.44A13.72 13.72 0 0 0 16 30zm6.22-17.5l-3.5 3.5 3.5 3.5-2.72 2.72-3.5-3.5-3.53 3.5-2.69-2.72 3.5-3.5-3.5-3.5 2.69-2.72 3.53 3.5 3.5-3.5z")
            span.validation-msg {{ messageTextValidationMessage }}

          input.btn.small.success.send-message(
            type="submit"
            value="Submit Message"
            @click.prevent="sendMessage()")

        message-thread(
          :messages="coachingMessages.messages"
          :coach="activeCoach"
          :patient="patient"
          :supervisorReviewDate="coachingMessages.supervisorReviewDate")

</template>
<script>
import CannedResponsePicker from '@/components/coaching/cannedResponses/CannedResponsePicker.vue';
import MessageThread from '@/components/coaching/coachingChat/MessageThread.vue';
import AttachmentInput from '@/components/coaching/coachingChat/AttachmentInput.vue';
import AttachmentList from '@/components/coaching/coachingChat/AttachmentList.vue';
import auth from '@/services/authSvc.js';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CoachingChat',
  components: {
    CannedResponsePicker,
    MessageThread,
    AttachmentInput,
    AttachmentList
  },
  props: [
    'user-id',
    'patient',
    'updatedOn',
    'isExpandedView',
    'isSupervisorView'
  ],
  data() {
    return {
      coachingMessagesLoaded: false,
      messageText: '',
      messageTextValidationMessage: '',
      isUsersCoach: false,
      draftEventSent: false,
      // Polling fallback
      messagePollInterval: null,
      messagePollDelay: 60000,
      // For canned response picker
      messageAttachments: [],
      cannedResponsePickerShown: false,
      socket: null
    };
  },
  computed: {
    userNotDisabled() {
      return this.coachingMessages.status !== 'DISABLED';
    },
    getMessageLocalStorageKey() {
      return `${this.userId}-coachMessage`;
    },
    getAttachmentsLocalStorageKey() {
      return `${this.userId}-coachMessageAttachments`;
    },
    activeCoach() {
      if (!this.coachingMessages || !this.coaches || this.coaches.length < 1) {
        return null;
      }
      return this.coaches.filter(
        item => item.id === this.coachingMessages.coachId
      )[0];
    },
    usersCoachId() {
      if (!this.user.id || !this.coaches || this.coaches.length < 1) {
        return null;
      }
      return this.coaches.filter(item => item.userId === this.user.id)[0]['id'];
    },
    ...mapGetters([
      'coaches',
      'coachingMessages',
      'user',
      'coachingMessageInternalLinkOptions',
      'apiConfig'
    ])
  },
  filters: {
    newLineToHtml(string) {
      return string.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }
  },
  methods: {
    init() {
      // Init websocket for real time message updates
      this.initChatWebsocket();
      // Setup localStorage for message
      this.initMessageLocalStorage();
      // Setup localStorage for attachments
      this.initAttachmentsLocalStorage();
    },
    initChatWebsocket() {
      // Prevent config response race condition - called again on apiConfig watch
      if (typeof this.apiConfig.platforms === 'undefined') {
        return;
      }

      // Polling fallback
      if (!this.apiConfig.platforms.web.features.websockets) {
        this.pollForNewMessages();
        return;
      }

      const urlPrefixRegex = new RegExp('^http(s?)', 'gm');
      const isHttps = new RegExp('^https:').test(auth.getApiUrl());
      const websocketBaseUrl = auth
        .getApiUrl()
        .replace(urlPrefixRegex, isHttps ? 'wss' : 'ws');

      this.socket = new WebSocket(`${websocketBaseUrl}/coaching/session`);

      // Authenticate using token on open
      this.socket.addEventListener('open', () => {
        this.socket.send(
          JSON.stringify({
            token: auth.getToken()
          })
        );
      });
      // Update thread on message from coach
      this.socket.addEventListener('message', event => {
        const data = JSON.parse(event.data);

        if (data.type !== 'FROM_COACH') {
          this.getCoachingMessageData(false);
        }
      });
    },
    pollForNewMessages() {
      if (this.messagePollInterval !== null) {
        return;
      }
      this.messagePollInterval = setInterval(() => {
        this.getCoachingMessages(this.userId);
      }, this.messagePollDelay);
    },
    clearMessagePollInterval() {
      if (this.messagePollInterval === null) {
        return;
      }
      clearInterval(this.messagePollInterval);
    },
    resetCoachingChat() {
      // Clear model and update coachingMessages
      this.clearMessageLocalStorage();
      this.clearAttachmentsLocalStorage();
      this.messageText = '';
      this.getCoachingMessages(this.userId);
      this.removeAllAttachments();
    },
    getCoachingMessageData(isInitialLoad) {
      this.getCoachingMessages(this.userId).then(() => {
        this.coachingMessagesLoaded = true;
        if (
          isInitialLoad &&
          this.activeCoach &&
          this.activeCoach.userId &&
          this.user.id === this.activeCoach.userId
        ) {
          this.isUsersCoach = true;
          this.markMessagesAsRead();
          this.logEvent('USER_VIEWED');
        }
      });
    },
    setIsUsersCoach() {
      this.isUsersCoach =
        this.activeCoach &&
        this.activeCoach.userId &&
        this.user.id === this.activeCoach.userId;
    },
    initMessageLocalStorage() {
      const keyName = this.getMessageLocalStorageKey;
      const currentValue = localStorage.getItem(keyName);

      if (currentValue === null || currentValue === '') {
        localStorage.setItem(keyName, '');
      } else {
        this.messageText = currentValue;
      }
    },
    updateMessageLocalStorage(messageText) {
      localStorage.setItem(this.getMessageLocalStorageKey, messageText);
    },
    clearMessageLocalStorage() {
      localStorage.removeItem(this.getMessageLocalStorageKey);
    },
    initAttachmentsLocalStorage() {
      const keyName = this.getAttachmentsLocalStorageKey;
      const currentValue = localStorage.getItem(keyName);

      if (!currentValue || currentValue === '') {
        localStorage.setItem(keyName, JSON.stringify([]));
      } else {
        this.messageAttachments = JSON.parse(currentValue);
      }
    },
    updateAttachmentsLocalStorage(attachments) {
      localStorage.setItem(
        this.getAttachmentsLocalStorageKey,
        JSON.stringify(attachments)
      );
    },
    clearAttachmentsLocalStorage() {
      localStorage.removeItem(this.getAttachmentsLocalStorageKey);
    },
    showCannedResponsePicker() {
      this.cannedResponsePickerShown = true;
    },
    closeCannedResponsePicker() {
      this.cannedResponsePickerShown = false;

      // Scroll to top of chat
      if (window.scroll) {
        this.$refs.scrollWrapper.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } else {
        this.$refs.scrollWrapper.scrollTo(0, 0);
      }
    },
    showExpandedCoachChat() {
      this.$emit('show-expanded-coach-chat');
    },
    hideExpandedCoachChat() {
      this.$emit('hide-expanded-coach-chat');
    },
    populateCoachMessage(messageData) {
      this.messageText = messageData.message;

      if (messageData.attachments.length > 0) {
        // Fix attachment object for API
        // - Removes coaching message template attachment specific properties
        this.messageAttachments = messageData.attachments.map(item => {
          // Clone to prevent vuex mutation errors
          let newItem = Object.assign({}, item);
          newItem.coachingMessageTemplateId = undefined;
          newItem.id = 0;
          return newItem;
        });
      }
    },
    addAttachment(attachment) {
      this.messageAttachments.push(attachment);
    },
    setAttachments(attachments) {
      this.messageAttachments = attachments;
    },
    removeAllAttachments() {
      this.messageAttachments = [];
    },
    focusMessageInput() {
      if (
        this.isUsersCoach &&
        this.userNotDisabled &&
        this.$refs.messageInput
      ) {
        setTimeout(() => {
          this.$refs.messageInput.focus();
        }, 300);
      }
    },
    validateMessage() {
      let isValid = true;

      if (this.messageText.trim().length === 0) {
        // Basic message validation - not empty
        this.messageTextValidationMessage =
          'Please input a message to send to the patient';
        isValid = false;
      } else if (this.stringContainsUrl(this.messageText)) {
        this.messageTextValidationMessage =
          'Please do not place links in the message body, instead use the attachment options to share content and links.';
        isValid = false;
      }

      return isValid;
    },
    sendMessage() {
      const hasMultipleAttachments = this.messageAttachments.length > 1;
      const messageValid = this.validateMessage();
      let messageInvalidInput = false;
      let messageWasSent = false;

      // Prevent sending message if validation fails
      if (!messageValid) {
        return;
      }

      // Reset validation message
      this.messageTextValidationMessage = '';

      // Send the message
      this.sendCoachingMessage({
        id: 0,
        userId: this.userId,
        coachId: this.activeCoach.id,
        status: 'SENT',
        message: this.messageText,
        attachments: this.messageAttachments
      })
        .catch(error => {
          // Handle invalid attachment error
          if (
            error.response.status === 422 &&
            error.response.data.errorCode === 'INVALID_INPUT'
          ) {
            messageInvalidInput = true;

            // Handle invalid ACTIVITY string
            this.messageTextValidationMessage = `Message ${
              hasMultipleAttachments ? 'attachments are' : 'attachment is'
            } invalid,
              please double check attachment${
                hasMultipleAttachments ? 's' : ''
              }.`;
          }
        })
        .then(
          () => {
            messageWasSent = true;
          },
          () => {
            // Handle generic send message error
            this.messageTextValidationMessage =
              'Your message was unable to be sent. Please reload the page and try again.';
          }
        )
        .finally(() => {
          // Done in this step so that any API errors can be fixed and sent successfully
          if (messageWasSent && !messageInvalidInput) {
            this.resetCoachingChat();
          }
        });
    },
    markMessagesAsRead() {
      // Prevent other coaches from setting read status
      if (this.user.id !== this.activeCoach.userId) {
        return;
      }

      this.coachingMessages.messages.forEach(messageData => {
        // Only set status on messages TO_COACH and where readOn is null
        if (
          messageData.type === 'TO_COACH' &&
          messageData.readOn === null &&
          messageData.coachId === this.usersCoachId
        ) {
          this.markCoachingMessageAsRead(messageData.id);
        }
      });
    },
    stringContainsUrl(string) {
      // Regex sourced from https://mathiasbynens.be/demo/url-regex - @stephenhay
      const urlRegex = /(https?|ftp):\/\/[^\s/$.?#].[^\s]*/gi;
      return urlRegex.test(string);
    },
    logDraft() {
      if (!this.draftEventSent) {
        this.logEvent('MESSAGE_DRAFTED');
        this.draftEventSent = true;
      }
    },
    logEvent(eventType) {
      const event = {
        eventType: eventType,
        coachingUserId: this.userId
      };
      this.sendCoachingEvent(event);
    },
    ...mapActions([
      'getCoaches',
      'getCoachingMessages',
      'sendCoachingMessage',
      'markCoachingMessageAsRead',
      'sendCoachingEvent',
      'getCoachingMessageInternalLinkOptions'
    ])
  },
  watch: {
    apiConfig: {
      deep: true,
      handler() {
        this.initChatWebsocket();
      }
    },
    messageText(newValue) {
      if (newValue.length > 0 && !this.draftEventSent) {
        this.logDraft();
      }
      this.updateMessageLocalStorage(newValue);
    },
    messageAttachments(newValue) {
      this.messageTextValidationMessage = '';
      this.updateAttachmentsLocalStorage(newValue);
    },
    messageAttachmentType(newType) {
      let humanReadableType = '';

      if (newType === 'ACTIVITY') {
        humanReadableType = 'activity identifier';
      } else if (newType === 'INTERNAL_LINK') {
        humanReadableType = 'internal URL';
      } else if (newType === 'EXTERNAL_LINK') {
        humanReadableType = 'external URL';
      }

      this.messageAttachmentInputPlaceholder = `Enter an ${humanReadableType}`;
    },
    coachingMessagesLoaded(newValue) {
      // Event to parent component
      this.$emit('coaching-messages-loaded', {
        coachUserId: this.activeCoach.userId
      });

      // Expanded view only - focus text area when coachingMessagesLoaded
      if (
        this.isExpandedView &&
        this.isUsersCoach &&
        this.userNotDisabled &&
        newValue
      ) {
        // Slight delay for DOM render of textarea
        setTimeout(() => {
          this.$refs.messageInput.focus();
        }, 100);
      }

      if (this.activeCoach) {
        this.setIsUsersCoach();
      }
    },
    updatedOn() {
      this.init();
    },
    activeCoach() {
      if (this.activeCoach) {
        this.setIsUsersCoach();
      }
    }
  },
  mounted() {
    // Get coaches before getting message data to prevent race condition
    if (this.coaches.length < 1) {
      this.getCoaches().then(() => {
        this.getCoachingMessageData(true);
      });
    } else {
      this.getCoachingMessageData(true);
    }
    // Fetch internal link options for internal attachments dropdown
    if (this.coachingMessageInternalLinkOptions.length < 1) {
      this.getCoachingMessageInternalLinkOptions();
    }

    this.init();
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.close();
    }
    if (!this.apiConfig.platforms.web.features.websockets) {
      this.clearMessagePollInterval();
    }
  }
};
</script>
<style lang="scss" scoped>
.coaching-chat-wrapper {
  flex: 0 0 30%;
  padding: $small-spacing;
  background: $md-blue-grey-50;
  overflow-y: auto;
  max-height: 90vh;

  // Style modifications for .expanded-view
  &.expanded-view {
    // Bump textarea height
    .compose-message textarea {
      height: 8em;
    }
  }

  .chat-history {
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
  }

  // Chat mode change animation
  .chat-canned-responses,
  .coaching-chat {
    opacity: 1;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    // Vue transition styles
    &.chat-mode-change-enter-active,
    &.chat-mode-change-leave-active {
      transition: opacity 0.3s ease;
      position: relative;
    }
    &.chat-mode-change-enter,
    &.chat-mode-change-leave-to {
      opacity: 0;
      position: absolute;
      padding: $small-spacing;
    }
  }

  .coaching-status {
    color: #fff;
    background-color: #6c757d;
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
  }
  .header-row {
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .chat-heading {
      padding-right: 10px;
    }

    .chat-actions {
      .btn {
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }
      .btn + .btn {
        margin: 0;
      }
    }

    button {
      padding: 11px 11px 10px;

      svg {
        margin-right: 0;
        height: 24px;
        width: 24px;
      }
    }
  }

  .compose-message {
    margin: 0 auto $small-spacing;

    textarea {
      background: #fff;
      min-height: 4.5em;
      margin-bottom: $xs-spacing;

      &:active,
      &:focus {
        outline: 1px solid $action-color;
        box-shadow: 0 0 0 rgba(#fff, 0);
      }
    }
    .send-message {
      width: 100%;
      text-align: center;
    }
  }

  .compose-message-validation {
    margin-bottom: 16px;
    font-size: 11px;
    font-weight: 600;
    color: $md-red-700;

    @include media-query-bp($bp5) {
      font-size: 14px;
    }

    &.info {
      color: $action-color;
    }

    div.svg-icon {
      display: inline;
      position: relative;
      top: 1px;

      svg {
        height: 17px;
        width: 17px;
      }
    }
    .validation-msg {
      line-height: 1.33;
      margin-left: 4px;
    }
  }
}
</style>
